import React from "react";
import { Grid } from "@mui/material";

import FeedbackSlider from "../components-generic/FeedbackSlider";
import FeedbackColorPicker from "../components-generic/FeedbackColorPicker";

import { WidthIcon, HeightIcon } from "../static/DimIcons";

// the feedback slider max values need to be controlled by a ratio between them
// bounds for width should be 360, 48
// bounds for height should be 180, 48


function ScopeMenu(props) {
  const { getProps, selectedMaterial } = props;

  
  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <FeedbackSlider
            // key="Width"
            label="Width"
            {...getProps("Scope: Width")}
            max={220}
            // min={48}
            defVal={150}
            icon={WidthIcon}
          />
        </Grid>
        <Grid item xs={12}>
          <FeedbackSlider
            // key="Height"
            label="Height"
            {...getProps("Scope: Height")}
            max={220}
            min={48}
            // defVal={100}
            icon={HeightIcon}
          />
        </Grid>
        <Grid item xs={12} >
          {selectedMaterial !== 0 ? (
            <Grid item xs={12}>
              <FeedbackColorPicker
                // key="Color"
                label="Background Color"
                {...getProps("BackgroundColor")}
                defVal="#000000"
              />
            </Grid>
          ) : null}
        </Grid>
        {/* <Grid>
      <FeedbackSelect
        name="Select Mullion Size"
        {...getProps("MullionSize")}
      />
    </Grid> */}
        {/* <Grid item xs={12}>
          <p />
          <Typography align="center" variant="h6">
            <a href={"https://www.azahner.com/contact/"}>Contact Us</a> to customize ImageLines for specific dimensions or
            conditions.
          </Typography>
        </Grid> */}
        {/* <Grid item xs={12}>
          <FeedbackButtonToggle
            option1="Wall"
            option2="Ceiling"
            setValue={setBool1}
            value={bool1}
          />
        </Grid> */}
      </Grid>
    </div>
  );
}

export default  React.memo(ScopeMenu);